export interface Bounds {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

/**
 * Pure hit-test backing the file-browser rubber-band (marquee) selection.
 *
 * Given a selection box and a set of cards (each with viewport-relative
 * bounds), returns the **entry id** of every card whose bounds intersect the
 * marquee, using axis-aligned bounding-box overlap. Input order is preserved.
 *
 * Ids, not display paths (STD-029 R-2): the marquee feeds the same selection
 * set as clicking does, so if it produced paths, two rows at one display path
 * would come back as one entry and the box would silently under-select.
 *
 * Kept DOM-free so it can be unit-tested without a layout engine; the
 * `useMarquee` hook supplies the bounds from each element's
 * `getBoundingClientRect()` and the id from its `data-entry-id`.
 */
export function idsIntersectingMarquee(
  marquee: Bounds,
  cards: ReadonlyArray<{ id: string; bounds: Bounds }>
): string[] {
  const ids: string[] = [];
  for (const card of cards) {
    const b = card.bounds;
    const intersects = !(
      b.right < marquee.left ||
      b.left > marquee.right ||
      b.bottom < marquee.top ||
      b.top > marquee.bottom
    );
    if (intersects) ids.push(card.id);
  }
  return ids;
}
